export enum PlaceType {
    REGION = 1,
    DEPARTMENT = 2,
    TOWN = 3,
    SECTION = 4,
    STREET = 5,
    SAID_PLACE = 6,
    ADDRESS = 7,
}
